export const CanvasBlendingMode = {
	NORMAL: 'normal',
	OVERLAY: 'overlay',
	MULTIPLY: 'multiply',
	SCREEN: 'screen',
	HARD_LIGHT: 'hard-light',
	DARKEN: 'darken',
	LIGHTEN: 'lighten',
};

export const CanvasBlendingModeToCompositeOperation = {
	[CanvasBlendingMode.NORMAL]: 'source-over',
	[CanvasBlendingMode.OVERLAY]: 'overlay',
	[CanvasBlendingMode.MULTIPLY]: 'multiply',
	[CanvasBlendingMode.SCREEN]: 'screen',
	[CanvasBlendingMode.HARD_LIGHT]: 'hard-light',
	[CanvasBlendingMode.DARKEN]: 'darken',
	[CanvasBlendingMode.LIGHTEN]: 'lighten',
};
